import { Plan } from "./plan";
import { IPlanWithMetadata } from "./plan-or-metadata";

export class Invoice implements IPlanWithMetadata {
	id:string = "";
	amount:number = 0;
	date:Date = new Date();
	status:string = "";
	plan:Plan;
	rawMetadata:any;

	public constructor(data:any){
		this.id = data.id;
		this.amount = data.amount;
		this.date = new Date(data.date * 1000);
		this.status = data.status;
		this.plan = new Plan(data.plan);
		this.rawMetadata = data.rawMetadata;
	}
}